import React, {useContext, useMemo} from "react";
import { Link } from "react-router-dom";
import context from "components/Shared/MSidebar/utility/context";
import {default as src} from "static/images/logo.png";

const DrawerLogo = () => {
  const {open} = useContext(context);
  const className = useMemo(
    () => open ? " DrawerLogo-Visible" : " DrawerLogo-Hidden",
    [open]
  );
  return (
  <Link to={"/"} className={`DrawerLogo-Root${className}`}>
      <img {...{src}} className={"DrawerLogo-Image"}/>
  </Link>
  );
};

export default DrawerLogo;